import React, { useCallback, useEffect, useState } from 'react';
import { Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, Grid, TextField, Typography } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CloseIcon from '@mui/icons-material/Close';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import { deleteRol, getRol, getRolesYDepartamentos, patchRol, postRol } from '../services/apis';
import { LoadingMaestro } from '../components/LoadingMaestro';
import { normalizarArray } from '../utils/apiResponse';

const permisosRol = [
    {
        key: 'puedeEditarPlanificacion',
        label: 'Editar planificacion',
    },
    {
        key: 'puedeEditarMaestrosGlobales',
        label: 'Maestros globales',
    },
    {
        key: 'puedeEditarMaestrosAlmacen',
        label: 'Maestros almacen',
    },
    {
        key: 'puedeSincronizarBusinessCentral',
        label: 'Sincronizar Business Central',
    },
    {
        key: 'puedeCrearUsuarios',
        label: 'Crear usuarios',
    },
];



export const RolesYDepartamnetos = () => {

    const [loaded, setLoaded] = useState(false);
    const [roles, setRoles] = useState([]);
    const [openCrearRol, setOpenCrearRol] = useState(false);
    const [rolEditandoId, setRolEditandoId] = useState(null);
    const [rolEliminar, setRolEliminar] = useState(null);
    const [nuevoRol, setNuevoRol] = useState({
        desRol: '',
        puedeEditarPlanificacion: false,
        puedeEditarMaestrosGlobales: false,
        puedeEditarMaestrosAlmacen: false,
        puedeSincronizarBusinessCentral: false,
        puedeCrearUsuarios: false,
    });

    const cargarOpciones = useCallback(async () => {

        try {
            setLoaded(false);
            const response = await getRolesYDepartamentos();
            const rolesData = normalizarArray(response, 'roles');

            console.log('Roles cargados:', rolesData);

            setRoles(rolesData);
            setLoaded(true);
        } catch (error) {
            console.error('Error al cargar los roles:', error);
            setLoaded(true);
        }
    }, []);


    useEffect(() => {
        cargarOpciones();
    }, [cargarOpciones]);

    const handleChangeNuevoRol = (event) => {
        const { name, value, checked, type } = event.target;

        setNuevoRol((rolActual) => ({
            ...rolActual,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleCloseCrearRol = () => {
        setOpenCrearRol(false);
        setRolEditandoId(null);
        resetNuevoRol();
    };

    const resetNuevoRol = () => {
        setNuevoRol({
            desRol: '',
            puedeEditarPlanificacion: false,
            puedeEditarMaestrosGlobales: false,
            puedeEditarMaestrosAlmacen: false,
            puedeSincronizarBusinessCentral: false,
            puedeCrearUsuarios: false,
        });
    };

    const abrirCrearRol = () => {
        resetNuevoRol();
        setRolEditandoId(null);
        setOpenCrearRol(true);
    };

    const abrirEditarRol = async (idRol) => {
        try {
            const response = await getRol(idRol);
            const rol = response?.data ?? response;

            setNuevoRol({
                desRol: rol.desRol || '',
                puedeEditarPlanificacion: Boolean(rol.puedeEditarPlanificacion),
                puedeEditarMaestrosGlobales: Boolean(rol.puedeEditarMaestrosGlobales),
                puedeEditarMaestrosAlmacen: Boolean(rol.puedeEditarMaestrosAlmacen),
                puedeSincronizarBusinessCentral: Boolean(rol.puedeSincronizarBusinessCentral),
                puedeCrearUsuarios: Boolean(rol.puedeCrearUsuarios),
            });
            setRolEditandoId(idRol);
            setOpenCrearRol(true);
        } catch (error) {
            console.error('Error al cargar el rol:', error);
        }
    };

    const guardarRol = async (event) => {
        event.preventDefault();

        const rolEnvio = {
            ...nuevoRol,
            desRol: nuevoRol.desRol.trim(),
        };

        try {
            if (rolEditandoId) {
                await patchRol(rolEditandoId, rolEnvio);
            } else {
                await postRol(rolEnvio);
            }
            resetNuevoRol();
            setRolEditandoId(null);
            setOpenCrearRol(false);
            cargarOpciones();
        } catch (error) {
            console.error('Error al guardar el rol:', error);
        }
    };

    const confirmarEliminarRol = async () => {
        if (!rolEliminar) return;

        try {
            await deleteRol(rolEliminar.idRol);
            setRolEliminar(null);
            cargarOpciones();
        } catch (error) {
            console.error('Error al eliminar el rol:', error);
        }
    };

    return (
        <Grid
            container
            direction="row"
            size={{ xs: 12 }}
            sx={{
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Grid
                container
                direction="row"
                size={{ xs: 10 }}
                sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    mt: 3,
                }}
                className='fade-in ajustes-compact'
            >
                <Grid container direction="column" size={{ xs: 12, sm: 7 }} sx={{ alignItems: "start" }}>
                    <Typography variant='h4'>
                        Roles
                    </Typography>
                </Grid>

                <Grid container direction="row" size={{ xs: 12, sm: 4, md: 3, lg: 2 }} sx={{ justifyContent: { xs: "start", sm: "end" } }}>
                    <Button variant="contained" fullWidth onClick={abrirCrearRol}>
                        <AddCircleIcon />&nbsp;Nuevo rol
                    </Button>
                </Grid>

                <Divider sx={{ mb: 2 }} />
            </Grid>

            {!loaded ? (
                <Grid container direction="row" size={{ xs: 10 }} sx={{ justifyContent: "center", alignItems: "center" }}>
                    <LoadingMaestro label="Cargando roles..." />
                </Grid>
            ) : (
                <>
                    <Grid
                        container
                        direction="row"
                        size={{ xs: 10 }}
                        sx={{
                            justifyContent: "start",
                            alignItems: "stretch",
                        }}
                        spacing={2}
                        className='fade-in'
                    >
                        {roles.map((rol, index) => (
                            <Grid
                                key={rol.idRol ?? rol.id ?? index}
                                container
                                direction="column"
                                size={{ xs: 12, md: 6, lg: 4 }}
                                sx={{
                                    justifyContent: "start",
                                    alignItems: "start",
                                    p: 2,
                                    gap: 1.5,
                                }}
                                className='card-main'
                            >
                                <Grid
                                    container
                                    direction="row"
                                    size={{ xs: 12 }}
                                    sx={{
                                        justifyContent: "space-between",
                                        alignItems: "start",
                                        gap: 1,
                                    }}
                                >
                                    <Typography variant='h6'>
                                        {rol.desRol || rol.nombre || rol.name || 'Rol sin nombre'}
                                    </Typography>

                                    <Chip size="small" label={`ID ${rol.idRol ?? rol.id ?? '-'}`} variant="outlined" />
                                </Grid>

                                <Grid
                                    container
                                    direction="row"
                                    size={{ xs: 12 }}
                                    sx={{
                                        justifyContent: "start",
                                        alignItems: "center",
                                        gap: 0.75,
                                    }}
                                >
                                    {permisosRol.map((permiso) => {
                                        const permitido = Boolean(rol[permiso.key]);

                                        return (
                                            <Chip
                                                key={permiso.key}
                                                size="small"
                                                label={permiso.label}
                                                color={permitido ? 'success' : 'default'}
                                                variant={permitido ? 'filled' : 'outlined'}
                                            />
                                        );
                                    })}
                                </Grid>

                                <Grid
                                    container
                                    direction="row"
                                    size={{ xs: 12 }}
                                    sx={{
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        gap: 1,
                                    }}
                                >
                                    <Button
                                        variant="text"
                                        color="primary"
                                        onClick={() => abrirEditarRol(rol.idRol ?? rol.id)}
                                    >
                                        <EditIcon />&nbsp;Editar
                                    </Button>

                                    <Button
                                        variant="text"
                                        color="error"
                                        onClick={() => setRolEliminar({ idRol: rol.idRol ?? rol.id, desRol: rol.desRol || rol.nombre || rol.name })}
                                    >
                                        <DeleteForeverIcon />&nbsp;Eliminar
                                    </Button>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </>
            )}

            <Dialog open={openCrearRol} onClose={handleCloseCrearRol} fullWidth maxWidth="sm">
                <form onSubmit={guardarRol}>
                    <DialogTitle>
                        <Grid
                            container
                            direction="row"
                            size={{ xs: 12 }}
                            sx={{
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <Typography variant="h5">
                                {rolEditandoId ? 'Editar rol' : 'Nuevo rol'}
                            </Typography>

                            <Button variant="text" color="negro" onClick={handleCloseCrearRol}>
                                <CloseIcon />
                            </Button>
                        </Grid>
                    </DialogTitle>

                    <DialogContent>
                        <Grid
                            container
                            direction="row"
                            size={{ xs: 12 }}
                            sx={{
                                justifyContent: "center",
                                alignItems: "center",
                                pt: 1,
                            }}
                            spacing={2}
                        >
                            <Grid container size={{ xs: 12 }}>
                                <TextField
                                    label="Descripcion del rol"
                                    name="desRol"
                                    value={nuevoRol.desRol}
                                    onChange={handleChangeNuevoRol}
                                    fullWidth
                                    required
                                />
                            </Grid>

                            <Grid
                                container
                                direction="column"
                                size={{ xs: 12 }}
                                sx={{
                                    justifyContent: "start",
                                    alignItems: "start",
                                    gap: 0.5,
                                }}
                            >
                                {permisosRol.map((permiso) => (
                                    <FormControlLabel
                                        key={permiso.key}
                                        control={
                                            <Checkbox
                                                name={permiso.key}
                                                checked={nuevoRol[permiso.key]}
                                                onChange={handleChangeNuevoRol}
                                            />
                                        }
                                        label={permiso.label}
                                    />
                                ))}
                            </Grid>
                        </Grid>
                    </DialogContent>

                    <DialogActions>
                        <Button color="primary" onClick={handleCloseCrearRol}>
                            Cancelar
                        </Button>

                        <Button color="primary" variant="contained" type="submit">
                            {rolEditandoId ? 'Guardar rol' : 'Crear rol'}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>

            <Dialog open={Boolean(rolEliminar)} onClose={() => setRolEliminar(null)} fullWidth maxWidth="xs">
                <DialogTitle>
                    Eliminar rol
                </DialogTitle>

                <DialogContent>
                    <Typography>
                        Desea eliminar el rol {rolEliminar?.desRol || ''}?
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <Button color="primary" onClick={() => setRolEliminar(null)}>
                        Cancelar
                    </Button>

                    <Button color="error" variant="contained" onClick={confirmarEliminarRol}>
                        Eliminar
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}
